export default __webpack_public_path__ + "static/media/Markers_Red Marker - Alert.06c2eede.svg";